module.exports = __webpack_public_path__ + "img/users.e91c3aa9.png";